<template>
  <div>
    <div class="wBh_hh_PhoneLayer">
      <div class="gs_GuaranteeLayer">
        <span class="wBh_Close"><img src="@/assets/bh_close.png"/></span>
        <h5 class="gs_GuaranteeLayer_Title">关于瀚华担保</h5>
        <div class="gs_Guarantee_Wrap clear">
          <!--第一页                 **************          开始-->
          <div class="gs_GuaranteeMain2 gs_GuaranteeMain_Active">
            <h3 class="gs_GuaranteeTitle"><i></i>关于瀚华</h3>
            <h5 class="gs_GuaranteeTitleBto hh__GuaranteeTitleBto">
              瀚华金融创立于2004年，2014年在香港联交所上市（股票代码：HK03903），
              是中国首家登陆国际资本市场的普惠金融集团，瀚华融资担保股份有限
              公司是瀚华金融旗下重要成员企业。瀚华金融历时十余年时间打造了囊括民营银行、资产管理、私募股权投资、融资担保、互联网信贷、保理、
              、保险经纪的多元金融生态，在28个重点省市设立了分支机构，业务能力覆盖全国。系政府采购、建筑施工领域金融服务专家，
              购、建筑施工企业等提供标前、标后全链条金融服务，服务企业近5000家，累计服务规模逾300亿元，具有丰富的行业资源和宝贵的行业经验。
            </h5>
            <h3 class="gs_GuaranteeTitle hh_GuaranteeTowTitle">
              <i></i>电子保函优势
            </h3>
            <h5 class="gs_GuaranteeTitleBto hh__GuaranteeTitleBto">
              以线上化、电子化保函替代传统纸质保函或保证金，足不出户、线上操作、1分钟出函、免保证金、信用保障、投标无忧。
            </h5>
            <ol class="gs_GuaranteeList hh_GuaranteeList clear">
              <li>
                <img src="@/assets/guarantee3.png" />
                <h3>成本低</h3>
                <h6>
                  <p>保函费用低廉</p>
                  <p>不占企业资金</p>
                </h6>
              </li>
              <li>
                <img src="@/assets/guarantee2.png" />
                <h3>效率高</h3>
                <h6>
                  <p>全程在线操作</p>
                  <p>系统自动签发</p>
                </h6>
              </li>

              <li>
                <img src="@/assets/xinyonghao.png" />
                <h3>信用好</h3>
                <h6>
                  <p>平台无缝对接</p>
                  <p>投标安全保障</p>
                </h6>
              </li>
            </ol>
            <h3 class="gs_GuaranteeTitle"><i></i>用户常见问题解答 ?</h3>
            <div class="wBh_QuestionWrap">
              <dl class="wBh_Question clear">
                <dd>Q:如何申请电子保函?</dd>
                <dt>
                  A:
                  登录电子招投标服务系统→选择项目报名→保证金缴纳方式选择电子保函→确认信息→选择“瀚华担保”→选择开票方式→费用生成→插入CA锁，
                  申请材料在线签章→提交订单→支付费用→审核→审批通过，
                  出具保函→保函电子档推送至公共资源交易中心招投标服务平台，同时客户手机接收反馈短信。
                </dt>
              </dl>
            </div>
          </div>
          <!--第一页                 **************          结束-->

          <!--第一页                 **************          开始-->
          <div class="gs_GuaranteeMain2">
            <div class="wBh_QuestionWrap hh_QuestionWrap">
              <dl class="wBh_Question clear">
                <dd>Q：保函怎么收费？</dd>
                <dt>
                  A：保函费用单笔收费，甘南地区及金塔县保函费率为保证金费用2%，最低收费标准800元，甘肃其他地区保函费率为保证金费用的2%，最低收费标准500元。
                </dt>
              </dl>
              <dl class="wBh_Question clear">
                <dd>Q: 是否需要提供抵押？</dd>
                <dt>A：纯信用担保，无需提供抵押物。</dt>
              </dl>
              <dl class="wBh_Question clear">
                <dd>Q：是否还需要提供纸质资料？</dd>
                <dt>A：不需要提供任何纸质资料，全程在线操作即可。</dt>
              </dl>
              <dl class="wBh_Question clear">
                <dd>Q: 保函有效期是多久？</dd>
                <dt>
                  A：自保函生效之日起至招标文件规定的投标有效期届满后30日，投标有效期延长的，本保函的保证期间做相应调整，但最晚不晚于开立之日起算365日历天。
                </dt>
              </dl>
              <dl class="wBh_Question clear">
                <dd>Q：保函开具后如何传递？如何下载保函电子档？</dd>
                <dt>
                  <p>A：保函传递--保函开具后，系统自动推送至交易中心平台。</p>
                  <p>
                    &nbsp;&nbsp;电子档下载--进入公航旅电子交易中心平台官网电子保函板块，在该页面输入公司名称及保函编号
                    ，即可下载保函电子档。
                  </p>
                </dt>
              </dl>
              <dl class="wBh_Question clear">
                <dd>Q：如何查询保函真伪？</dd>
                <dt>
                  A：登录瀚华官网首页http://www.hanhua.com/，进入“瀚华担保”--“保函查询”，输入保函编号及查询代码，即刻查询保函真伪。
                </dt>
              </dl>
            </div>
          </div>
          <!--第一页                 **************          结束-->
        </div>
        <!--分页                 **************          开始-->
        <div class="gs_GuaranteePage clear">
          <ol class="clear">
            <li class="gs_PageBtn gs_PageLeft">
              <span><img src="@/assets/pageLeft.png"/></span>
            </li>
            <ul class="pageNumWrap2 clear">
              <li class="pageNum active"><span>1</span></li>
              <li class="pageNum"><span>2</span></li>
            </ul>
            <li class="gs_PageBtn gs_PageRight">
              <span><img src="@/assets/pageRight.png"/></span>
            </li>
          </ol>
        </div>
        <!--分页                 **************          结束-->
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

import "@/assets/css/about_danbao.css";

export default {
  name: "register",
  data() {
    return {};
  },
  mounted() {
    var that = this;
    var $li = $(".pageNumWrap2 li");
    var len = $li.length - 1;
    var _index = 0; //li的索引
    var $img = $(".gs_GuaranteeMain2");
    play();
    //点击事件
    $li.click(function() {
      _index = $(this).index();
      play();
    });

    function play() {
      //获取li的下标，改变样式
      $li
        .eq(_index)
        .addClass("active")
        .siblings()
        .removeClass("active");
      //获取图片的下标，实现淡入淡出
      $img
        .eq(_index)
        .slideDown()
        .siblings()
        .slideUp();
    }

    //两边耳朵的点击事件
    $(".gs_PageBtn").click(function() {
      var index = $(this).index();
      if (index) {
        _index++;
        if (_index > len) {
          _index = 0;
        }
        play();
      } else {
        _index--;
        if (_index < 0) {
          _index = len;
        }
        play();
      }
    });
    layui.use(
      ["jquery", "element", "step", "form", "laydate", "layer", "table"],
      function() {
        var $ = layui.jquery,
          form = layui.form,
          step = layui.step,
          element = layui.element,
          table = layui.table,
          layer = layui.layer,
          laydate = layui.laydate;
      }
    );
  },
  beforeCreate() {
    // console.group('beforeCreate 创建前状态===============》');
  },
  created() {
    // loadingInstance.close();
  }
};
</script>

<style></style>
